import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormSelectGroup } from "go-form/components/FormSelect";
import {
	VenueSettingsApi,
	VenueSettingsKioskOrderType,
} from "../../../../../../../../../../../../services/Api/Organization/types";

interface Props {
	form: UseFormReturn<VenueSettingsApi>;
}

const KioskSettingsOrderTypes = ({ form }: Props) => {
	const { t } = useTranslation();
	const {
		formState: { errors },
		control,
		watch,
	} = form;
	const orderTypes = [VenueSettingsKioskOrderType.DINE_IN, VenueSettingsKioskOrderType.PICK_UP];
	const orderTypeOptions = orderTypes.map((type) => ({ value: type, label: t(`enums.orders.types.${type}`) }));

	return (
		<fieldset className="form-group">
			<h6>{t("modules.venue_settings.field.order_types.title")}</h6>
			<FormSelectGroup
				errors={errors}
				control={control}
				options={orderTypeOptions}
				name="kiosk.order_types"
				isMulti
				defaultValue={(watch("kiosk.order_types") || []).map((type) => ({
					value: type,
					label: type ? t(`enums.orders.types.${type}`) : "",
				}))}
				data-testid="kiosk.order_types"
			/>
		</fieldset>
	);
};

export default KioskSettingsOrderTypes;
